// extracted by mini-css-extract-plugin
export default {"header__image":"Header_header__image__RvlxP","btn-discord":"Header_btn-discord__cn6o4"};